import { render, staticRenderFns } from "./changeUser.vue?vue&type=template&id=cafcd388&scoped=true"
import script from "./changeUser.vue?vue&type=script&lang=js"
export * from "./changeUser.vue?vue&type=script&lang=js"
import style0 from "./changeUser.vue?vue&type=style&index=0&id=cafcd388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafcd388",
  null
  
)

export default component.exports